export const DefaSelectComponent = {
	props   : [ 'value', 'disabled', 'options' ],
	template: `
		<select
			class="select-dropdown"
			:disabled="disabled"
			:value="value"
			v-on:change="$emit('change', $event.target.value)"
		>
			<option disabled :value="0">Select a speed threshold</option>
			<option v-for="option in options" v-bind:value="option.value">
				{{ option.text }}
			</option>
		</select>
	`
};

export const DefaSelectComponentPlugin = {
	install(Vue, options) {
		Vue.component('defa-select-dropdown', DefaSelectComponent)
	}
};
